import API from "../instances/API";
import { clearTokens } from "../../storage/helpers";
import useGlobalStore from "src/store/useGlobalStore";

const responseInterceptor = () =>
  API.interceptors.response.use(
    (response) =>
      new Promise((resolve) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
      const { status } = error.response;

      if (status === 401) {
        const globalStore = useGlobalStore.getState();
        clearTokens();
        globalStore.handle401();
        return;
      }

      return Promise.reject(error);
    },
  );

export default responseInterceptor;
